<template>
  <div>
    <Heade> <template v-slot:title>首页</template></Heade>
    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white" >
      <van-swipe-item>
        <img src="../../assets/img/750-1.png" alt="">
      </van-swipe-item>
       <van-swipe-item>
        <img src="../../assets/img/750-2.png" alt="">
      </van-swipe-item>
    </van-swipe>

    <div class="modules">
      <div class="f-row">
        <!-- <div class="content" @click="entrance('/Sign')">
          <div class="left">
            <div class="up">首次参会</div>
            <div class="down">请先签到</div>
          </div>
          <div class="right">
            <div class="up"><img src="../../assets/img/01-1.png" alt=""></div>
            <div class="down">会议签到</div>
          </div>
        </div> -->
        <div class="content" @click="entrance('/Live')">
          <div class="left">
            <div class="up" style="color:#016ebf">急先锋</div>
            <div class="down">点击参会</div>
          </div>
          <div class="right">
            <div class="up"><img src="../../assets/img/01-2.png" alt=""></div>
            <div class="down">在线参会</div>
          </div>
        </div>
        <div class="content" @click="entrance('/RebroadcastList')">
          <div class="left">
            <div class="up" style="color:#f52a05">直播回看</div>
            <div class="down">反复回味</div>
          </div>
          <div class="right">
            <div class="up"><img src="../../assets/img/01-3.png" alt=""></div>
            <div class="down">精彩讲解</div>
          </div>
        </div>
      </div>
      <div class="f-row">
         <!-- <div class="content" @click="entrance('/RebroadcastList')">
          <div class="left">
            <div class="up" style="color:#f52a05">精彩讲解</div>
            <div class="down">反复回味</div>
          </div>
          <div class="right">
            <div class="up"><img src="../../assets/img/01-3.png" alt=""></div>
            <div class="down">直播回看</div>
          </div>
        </div> -->
        <div class="content" @click="entrance('/dakaShuo')">
          <div class="left">
            <div class="up" style="color:#f52a05">大咖说</div>
            <div class="down">反复回味</div>
          </div>
          <div class="right">
            <div class="up"><img src="../../assets/img/大咖说.png" alt=""></div>
            <div class="down">大咖说</div>
          </div>
        </div>
        <div class="content" @click="entrance('/jizhenkeVedio')">
          <div class="left">
            <div class="up" style="color:#009B91">急诊科故事</div>
            <div class="down">点击播放</div>
          </div>
          <div class="right">
            <div class="up"><img src="../../assets/img/01-6.png" alt=""></div>
            <div class="down">微视频</div>
          </div>
        </div>
      </div>
      <!-- <div class="f-row">
         <div class="content" @click="entrance('/jinengVedio')">
          <div class="left">
            <div class="up" style="color:#3399FF">技能视频</div>
            <div class="down">值得学习</div>
          </div>
          <div class="right">
            <div class="up"><img src="../../assets/img/01-5.png" alt=""></div>
            <div class="down">急救科普</div>
          </div>
        </div>        
        <div class="content">
          <div class="left">
            <div class="up" style="color:#ad2c45">会议资料</div>
            <div class="down">敬请查看</div>
          </div>
          <div class="right">
            <div class="up"><img src="../../assets/img/01-4.png" alt=""></div>
            <div class="down">会议资料</div>
          </div>
        </div>
      </div> -->
    </div>
    <div class="downbox">
      <div class="flextit">
        <div class="ttt">指南共识</div>
        <div class="desc">共6篇</div>
      </div>
      <div class="item" @click="openUrl('attachment/ST段抬高型心肌梗死患者急诊PCI微循环保护策略中国专家共识.pdf')">
        <div class="lef">专家<br>共识</div>
        <div class="rig">ST段抬高型心肌梗死患者急诊PCI微循环保护策略中国专家共识</div>
      </div>
      <div class="item" @click="openUrl('attachment/2018·ST段抬高型急性心肌梗死院前溶栓治疗中国专家共识.pdf')">
        <div class="lef" style="background:#4DC6BE">专家<br>共识</div>
        <div class="rig">2018·ST段抬高型心肌梗死院前溶栓治疗中国专家共识</div>
      </div>
      <div class="item" @click="openUrl('attachment/急性ST段抬高型心肌梗死诊断和治疗指南2019年.pdf')">
        <div class="lef" style="background:#CCA161">治疗<br>指南</div>
        <div class="rig">急性ST段抬高型心肌梗死诊断和治疗指南2019年</div>
      </div>
      <div class="item" @click="openUrl('attachment/2019·急性冠脉综合征急诊快速诊治指南.pdf')">
        <div class="lef" style="background:#61B2CC">诊治<br>指南</div>
        <div class="rig">2019·急性冠脉综合征急诊快速诊治指南</div>
      </div>
      <div class="item" @click="openUrl('attachment/2019·急性ST段抬高型心肌梗死溶栓治疗的合理用药指南(第2版).pdf')">
        <div class="lef" style="background:#5E62CC">用药<br>指南</div>
        <div class="rig">2019·急性ST段抬高型心肌梗死溶栓治疗的合理用药指南（第2版）</div>
      </div>
      <div class="item" @click="openUrl('attachment/北京协和医院在新型冠状病毒肺炎流行期间治疗急性心肌梗死建议.pdf')">
        <div class="lef" style="background:#3BB2EE">治疗<br>建议</div>
        <div class="rig">北京协和医院在新型冠状病毒肺炎流行期间治疗急性心肌梗死建议</div>
      </div>
    </div>
    <div class="icon">
      <div class="icontext">上滑查看更多</div>
      <img src="../../assets/img/pullwhite.png">
    </div>
    <!-- <div class="advertising"  @click="openUrl"> -->
      <!-- <img src="../../assets/img/广告内容.png" alt=""  @click="openUrl"> -->
      <!-- <div>{{bottomDesc}}</div> -->
    <!-- </div> -->
  </div>
</template>
<script>
import { Toast } from "vant";
export default {
  data() {
    return {
      bottomUrl: '',
      bottomDesc: '急性ST段抬高型心肌梗死溶栓治疗的合理用药指南'
    };
  },
  // 接收来自父组件的数据
  props: {},
  // 生命周期实例创建完成后被立即调用
  created() {},
  // 生命周期挂载完成之后被调用
  mounted() {
    this.getButtomUrl()
    // const openid = sessionStorage.getItem("openid");
     const openid = this.$store.state.openId
    console.log('openid',openid)
    if (openid == "null" || openid == "" || openid == null) {
      var weiCode = this.getQueryString("code");
      console.log("weiCode", weiCode);
      this.getOpenid(weiCode);
    }
  },
  // 组件
  components: {},
  // 方法
  methods: {
    //获取底部连接
    getButtomUrl(){
      const url = "/jxf/getButtomUrl";
      this.axios.post(url,{}).then(res => {
        if (res.data.code === "00000") {
          console.log('获取底部连接',res); 
          this.bottomUrl = res.data.model.url   
          this.bottomDesc = res.data.model.desc    
        }
      });
    },
    openUrl(url){
      this.$router.push({
        path:'/pdf',
        query:{
          url: url,
        }
      })
      // this.$router.push({ path:'/PDFN', query: { url: url} })
    },
    // 进入某一个页面
    entrance(path) {
      this.$router.push(path);
    },
    getOpenid(weiCode) {
      const _this = this;
      const url = "/queryWeiXin";
      var xhr = new XMLHttpRequest();
      xhr.open("post", "https://rhgt.api.anlongmaide.com" + url, true);
      xhr.setRequestHeader(
        "Content-type",
        "application/x-www-form-urlencoded;charset=UTF-8"
      );
      var data = { code: weiCode };
      let ret = "";
      for (const it in data) {
        ret +=
          encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
      }
      xhr.send(ret);
      xhr.onreadystatechange = function() {
        if (xhr.status == 200 && xhr.readyState == 4) {
          const data = JSON.parse(xhr.responseText);
          console.log("微信openid",data.weixin)
          if (data.weixin) {
            sessionStorage.setItem("openid", data.weixin);
            _this.$store.commit("setOpenId", data.weixin);
          } else {
            let urlQian =  location.href.split('?')[0]                            
            let urlHou = location.href.split('#')[location.href.split('#').length-1]
            let Url = `${urlQian}#${urlHou}`;
            let shareUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxcc0a796f6b6cfa33&redirect_uri=${encodeURIComponent(Url)}&res&response_type=code&scope=snsapi_base&state=STATE&connect_redirect=1#wechat_redirect`
            // window.location.href = shareUrl
            // _this.$store.commit("setOpenId", '819819819681651818');
            // sessionStorage.setItem("openid", "819819819681651818");
          }
           console.log("store微信openid",_this.$store.state.openId)
        }
      };
    },
    handleOpen() {
      window.open('http://cas.medline.org.cn/login?service=http%3A%2F%2Frs.yiigle.com%3A80%2Fm%2Fyufabiao%2F1180581.htm%3Ffrom%3Dgroupmessage%26isappinstalled%3D0&gateway=true&loginUrl=%2F')
    },
    // 处理地址
    getQueryString(name) {
      const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      const r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    }
  },
  // 监视
  watch: {}
};
</script>
<style lang="less" scoped>
.my-swipe {
  color: #fff;
  font-size: 40px;
  height: 422px;
  line-height: 422px;
  text-align: center;
  background-color: #39a9ed;
}
.modules {
  width: 100%;
  margin-top: 20px;
  .f-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 0 20px;
    margin-bottom: 20px;
    .content {
      width: 345px;
      height: 170px;
      border-radius: 10px;
      background: #e5e5e5;
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
      padding: 0 42px 0 45px;
      .left {
        .up {
          font-size: 30px;
          color: #7d00ab;
        }
        .down {
          margin-top: 22px;
          font-size: 24px;
          color: #666666;
        }
      }
      .right {
        .up {
          width: 88px;
          height: 88px;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .down {
          margin-top: 18px;
          font-size: 24px;
          color: #000000;
          font-weight: bold;
        }
      }
    }
  }
}
.advertising{
  width: 100%;
  height: 235px;
  display: flex;
  align-items: center;
  // justify-content: center;
  margin-top: 60px;
  background-image: url('../../assets/img/广告内容.png');
  background-size: 100%;
  // position: fixed;
  // bottom: 0;
  // left: 0;
  img{
    width: 100%;
    height: 100%;
  }
  div{
    width: 59%;
    // border: 1px solid red;
    margin-left: 40px;
    color: #2548A1;    
    font-size: 26px;
    font-weight: bold;
  }
}
// @media screen and (max-height: 700px) {
//   .advertising{
//     margin-top: 50px;
//     width: 100%;
//     height: 235px;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     img{
//       width: 100%;
//       height: 100%;
//     }
//   }
// }
.my-swipe{
  img{
    width: 100%;
    height: 100%;
  }
}
.downbox{
  padding: 20px 20px 80px;
}
.flextit{
  display: flex;
  justify-content: space-between; 
  margin-bottom: 20px; 
  .ttt{
    font-size: 30px;
    // font-weight: bold;
  }
  .desc{
    font-size: 26px;
  }
}
.item{
  display: flex;
  width: 100%;
  background: #FFFFFF;
  box-shadow: 0px 1px 0px 1px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  padding: 16px;
  align-items: center;
  margin-bottom: 12px;
  .lef{
    width: 88px;
    height: 88px;
    background: #3B94EE;
    border-radius: 4px;
    font-size: 26px;
    font-weight: bold;
    flex-shrink: 0;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;    
  }
  .rig{
    font-size: 26px;
    font-weight: bold;
    color: #333333;
    margin-left: 12px;
  }
}
div{
  box-sizing: border-box;
}
.icon{
  padding: 8px 20px;
  background: #000000b3;
  position: fixed;
  left: 35vw;
  bottom: 30px;
  display: flex;
  align-items: center;
  color: white;
  border-radius: 6px;
  .icontext{
    font-size: 24px;
  }  
  img{
    width: 36px;
  }
}
</style>
